export default {
    addCollecte(state, collecte) {
        state.collectes.push(collecte);
    },
    updateCollecte(state, { oldCollecte, newCollecte }) {
        state.collectes.splice(state.collectes.indexOf(oldCollecte), 1, newCollecte);
    },
    setState(state, { field, value }) {
        Object.assign(state, {
            [field]: value
        })
    },
}